import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayStatement } from "@wingspanhq/wingspan-api-sdk";
import take from "lodash/take";

import { PAYROLL_CURRENCY } from "../../constants";
import { selectorPayStatementEmployeeName } from "../../selectors/selectorPayStatementEmployeeName";
import { selectorPayStatementWorkLogIds } from "../../selectors/selectorPayStatementWorkLogIds";
import { parsePayrollAmount } from "../../utils";

const VISIBLE_WORK_LOGS = 3;

const selectWorkLogsSecondaryText = (
  workLogIds: string[]
): string | undefined => {
  const remaining = workLogIds.length - VISIBLE_WORK_LOGS;
  return remaining > 0 ? `+ ${remaining} more` : undefined;
};

export const getColumns = (): WSTableColumn<PayStatement>[] => [
  {
    config: { header: { text: "Employee" }, gridTemplateSizeMax: "2fr" },
    renderFunction: rowItem => (
      <WSTableCell
        secondaryText={rowItem.data.payeeAccountId}
        text={selectorPayStatementEmployeeName(rowItem.data)}
      />
    )
  },
  {
    config: { header: { text: "Work log #" }, gridTemplateSizeMax: "2fr" },
    renderFunction: rowItem => {
      const workLogIds = selectorPayStatementWorkLogIds(rowItem.data);

      return (
        <WSTableCell
          secondaryText={selectWorkLogsSecondaryText(workLogIds)}
          text={take(workLogIds, VISIBLE_WORK_LOGS).join(", ")}
        />
      );
    }
  },
  {
    config: { header: { text: "Net amount" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(
          parsePayrollAmount(rowItem.data.amountDetails?.netPay),
          PAYROLL_CURRENCY
        )}
      />
    )
  },
  {
    config: { header: { text: "Gross amount" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(
          parsePayrollAmount(rowItem.data.amountDetails?.grossPay),
          PAYROLL_CURRENCY
        )}
      />
    )
  }
];
